/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react/destructuring-assignment */
import { Badge, Divider, Grid, Group, Paper, Space } from '@mantine/core';
import { ReferenciaCodigo } from '../../../../../business/events/general';
import PageSection from '../../../../../components/core/PageSection/PageSection';
import PageViewProperty from '../../../../../components/core/PageViewProperty/PageViewProperty';
import ProfileCardLink from '../../../../../components/core/ProfileCardLink/ProfileCardLink';
import { EntityTypeType, UnitOfMeasureType } from '../../../../../models/core/cache.type';
import { EventType } from '../../../../../models/core/events.type';
import { Feature } from '../../../../../utils/constants.utils';
import { formatCurrency } from '../../../../../utils/formatter.utils';
import EventResidueReferenceEditor from '../../components/EventResidueReferenceEditor';
import EventServiceView from './ReferenceView/Service/EventServiceView';

type DataViewProps = {
  data: EventType;
  referenceData: {
    entityTypeData?: EntityTypeType[];
    unitOfMeasures: UnitOfMeasureType[];
  };
  zIndex: number;
};

export default function ReferenceView(props: DataViewProps) {
  const clienteLocalData =
    props.data.referencia?.contrato?.residuo || props.data.referencia?.contrato?.servico || null;
  const propostaContato = props.data.referencia?.contrato?.proposta || null;

  const encontrarPlanoResiduo = () => {
    const residuo = props.data.referencia?.contrato?.residuo;
    if (!residuo) {
      return null;
    }

    if (props.data.codigoEventoReferencia === ReferenciaCodigo.ContratoResiduoAcondicionamento) {
      return (
        residuo.planos?.find(
          (plano: any) =>
            plano.acondicionamentos?.findIndex(
              (x: any) => x.idPropostaResiduoPlanoAcondicionamento === props.data.idEventoReferencia2
            ) > -1
        ) || null
      );
    }

    if (props.data.codigoEventoReferencia === ReferenciaCodigo.ContratoResiduoEquipamento) {
      return (
        residuo.planos?.find(
          (plano: any) =>
            plano.equipamentos?.findIndex(
              (x: any) => x.idPropostaResiduoPlanoEquipamento === props.data.idEventoReferencia2
            ) > -1
        ) || null
      );
    }

    if (props.data.codigoEventoReferencia === ReferenciaCodigo.ContratoResiduoPlano) {
      return (
        residuo.planos?.find((x: any) => x.idPropostaResiduoPlano === props.data.idEventoReferencia2) || null
      );
    }

    return null;
  };

  const montarDocumento = () => {
    const documento = props.data.referencia!.entidade.documento!;
    const entidade = props.data!;

    return (
      <Paper shadow="xs" p="md" withBorder>
        <Grid columns={6}>
          <Grid.Col span={2}>
            {entidade!.CNPJ ? (
              <PageViewProperty
                label="Entidade"
                text={
                  <ProfileCardLink
                    id={entidade.idEntidade?.toString() || ''}
                    name={entidade.nomeFantasia || entidade.razaoSocial || '-'}
                    nameSize="sm"
                    description={entidade!.nomeFantasia ? entidade!.razaoSocial : entidade!.CNPJ}
                    descriptionSize="xs"
                    linkPrefix="entities"
                    showLink
                  />
                }
                size="sm"
              />
            ) : (
              <PageViewProperty
                label="Entidade"
                text={
                  <ProfileCardLink
                    id={entidade.idEntidade?.toString() || ''}
                    name={entidade.nome || '-'}
                    nameSize="sm"
                    description={entidade!.CPF}
                    descriptionSize="xs"
                    linkPrefix="entities"
                    showLink
                  />
                }
                size="sm"
              />
            )}
          </Grid.Col>
          <Grid.Col span={2}>
            <PageViewProperty
              label="Documento"
              text={
                <ProfileCardLink
                  id={documento.idEntidadeDocumento?.toString() || '-1'}
                  name={documento?.documentoTipo || documento?.outroTipo || '-'}
                  nameSize="sm"
                  description={documento.numeroDocumento || documento.observacao}
                  descriptionSize="xs"
                  showLink={false}
                />
              }
              size="sm"
            />
          </Grid.Col>
        </Grid>
      </Paper>
    );
  };

  const montarComissao = () => {
    const comissao = props.data.referencia!.comissao!;

    return (
      <Paper shadow="xs" p="md" withBorder>
        <Grid columns={6}>
          <Grid.Col span={2}>
            {comissao.cnpj ? (
              <PageViewProperty
                label="Entidade"
                text={
                  <ProfileCardLink
                    id={comissao.idEntidade?.toString() || ''}
                    name={comissao.nomeFantasia || comissao.razaoSocial || '-'}
                    nameSize="sm"
                    description={comissao!.nomeFantasia ? comissao!.razaoSocial : comissao!.cnpj}
                    descriptionSize="xs"
                    linkPrefix="entities"
                    showLink
                  />
                }
                size="sm"
              />
            ) : (
              <PageViewProperty
                label="Entidade"
                text={
                  <ProfileCardLink
                    id={comissao.idEntidade?.toString() || ''}
                    name={comissao.nome || '-'}
                    nameSize="sm"
                    description={comissao!.cpf}
                    descriptionSize="xs"
                    linkPrefix="entities"
                    showLink
                  />
                }
                size="sm"
              />
            )}
          </Grid.Col>
          <Grid.Col span={1}>
            <PageViewProperty
              label="Porcentagem"
              text={comissao?.porcentagem ? `${comissao.porcentagem}%` : '-'}
              size="sm"
            />
          </Grid.Col>
          <Grid.Col span={1}>
            <PageViewProperty
              label="Preço"
              text={comissao?.preco ? formatCurrency(comissao.preco || 0) : '-'}
              size="sm"
            />
          </Grid.Col>
          <Grid.Col span={1}>
            <PageViewProperty label="Ocorrências" text={comissao?.ocorrencia || '-'} size="sm" />
          </Grid.Col>
        </Grid>
      </Paper>
    );
  };

  const montarResiduo = () => {
    const residuo = props.data.referencia!.contrato.residuo!;
    const isCustomReferenceFlow = !!props.data.personalizado || props.data.idEventoReferencia2 === null;
    const planoInicial = encontrarPlanoResiduo();
    const selectedPlanId =
      props.data.codigoEventoReferencia === ReferenciaCodigo.ContratoResiduoPlano
        ? props.data.idEventoReferencia2
        : planoInicial?.idPropostaResiduoPlano || props.data.idEventoReferencia2;

    return (
      <EventResidueReferenceEditor
        referenceData={{
          entityTypeData: props.referenceData.entityTypeData || [],
          unitOfMeasures: props.referenceData.unitOfMeasures,
        }}
        residue={residuo}
        event={props.data}
        selectedPlanId={selectedPlanId}
        forceSingleCustomFlow={isCustomReferenceFlow}
        disabled
        zIndex={props.zIndex + 1}
      />
    );
  };

  const montarServico = () => {
    const servico = props.data.referencia!.contrato.servico!;
    const item = props.data.servico!;

    return (
      <Paper shadow="xs" p="md" withBorder>
        <Group justify="space-between">
          <Group>
            <ProfileCardLink
              id={servico.idServico.toString()}
              name={servico.servico}
              nameSize="md"
              description={servico.servicoDescricao}
              descriptionSize="sm"
              linkPrefix="services"
              showLink={false}
            />
            <Badge variant="outline" size="md" color={Feature.Home.Event.color}>
              {`${servico.residuoAcondicionamento || servico.residuoEquipamento || 'Fornecedor'}`}
            </Badge>
          </Group>
        </Group>
        <Space h="sm" />

        <EventServiceView data={item} event={props.data} />
      </Paper>
    );
  };

  return (
    <div>
      {clienteLocalData && (
        <>
          <Paper shadow="xs" p="md" withBorder>
            <PageSection
              size="lg"
              color={Feature.Home.Event.color}
              label="Cliente e Local"
              text="Cliente e local onde a prestação de serviço deverá ocorrer."
            />
            <Space h="xs" />

            <Grid columns={6}>
              <Grid.Col span={2}>
                {clienteLocalData.clienteCNPJ ? (
                  <ProfileCardLink
                    id={clienteLocalData.idCliente?.toString() || ''}
                    name={clienteLocalData.clienteNomeFantasia || clienteLocalData.clienteRazaoSocial || '-'}
                    nameSize="sm"
                    description={
                      clienteLocalData.clienteNomeFantasia
                        ? clienteLocalData.clienteRazaoSocial
                        : clienteLocalData.clienteCNPJ
                    }
                    descriptionSize="xs"
                    linkPrefix="entities"
                    showLink
                  />
                ) : (
                  <ProfileCardLink
                    id={clienteLocalData.idCliente?.toString() || ''}
                    name={clienteLocalData.clienteNome || '-'}
                    nameSize="sm"
                    description={clienteLocalData.clienteCPF}
                    descriptionSize="xs"
                    linkPrefix="entities"
                    showLink
                  />
                )}
              </Grid.Col>
              {propostaContato && (
                <Grid.Col span={2}>
                  <ProfileCardLink
                    id={propostaContato?.idEntidadeContato.toString() || '-1'}
                    name={propostaContato?.nome || '-'}
                    nameSize="sm"
                    description={
                      propostaContato?.telefone ||
                      propostaContato?.celular ||
                      propostaContato?.email ||
                      propostaContato?.setor
                    }
                    descriptionSize="xs"
                    showLink={false}
                  />
                </Grid.Col>
              )}
            </Grid>
            <Divider my="sm" />

            <Grid columns={6}>
              <Grid.Col span={2}>
                <PageViewProperty
                  label="Logradouro"
                  text={`${clienteLocalData.logradouro}, ${clienteLocalData.numero}${
                    clienteLocalData.complemento ? ` | ${clienteLocalData.complemento}` : ''
                  }`}
                  size="sm"
                />
              </Grid.Col>
              <Grid.Col span={2}>
                <PageViewProperty
                  label="Bairro - Cidade"
                  text={`${clienteLocalData.bairro} - ${clienteLocalData.cidade} / ${clienteLocalData.codigoEstado}`}
                  size="sm"
                />
              </Grid.Col>
              <Grid.Col span={1}>
                <PageViewProperty label="CEP" text={clienteLocalData.cep} size="sm" />
              </Grid.Col>
            </Grid>
          </Paper>
          <Space h="lg" />
        </>
      )}

      <Paper shadow="xs" p="md" withBorder>
        <PageSection
          size="lg"
          color={Feature.Home.Event.color}
          label={props.data.eventoTipo || 'Referência'}
          text="Informações detalhadas do evento como resíduo, serviço, documento, cliente, local, fornecedores, etc."
        />
        <Space h="xs" />

        {(props.data.codigoEventoReferencia === ReferenciaCodigo.ContratoResiduoAcondicionamento ||
          props.data.codigoEventoReferencia === ReferenciaCodigo.ContratoResiduoEquipamento ||
          props.data.codigoEventoReferencia === ReferenciaCodigo.ContratoResiduoPlano) &&
          montarResiduo()}

        {props.data.codigoEventoReferencia === ReferenciaCodigo.ContratoServico && montarServico()}

        {props.data.codigoEventoReferencia === ReferenciaCodigo.EntidadeDocumento && montarDocumento()}

        {props.data.codigoEventoReferencia === ReferenciaCodigo.ContratoComissao && montarComissao()}
      </Paper>
    </div>
  );
}
